<template>
  <div class="section-box box">
    <el-row type="flex" class="row-bg" justify="end" v-if="!(typeof(actionData.examinationkc_add) != 'undefined'&&!actionData.examinationkc_add)">
      <el-col :span="24" style="text-align: right;">
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">
            创建考试<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">选题组卷</el-dropdown-item>
            <el-dropdown-item command="b">随机组卷</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <el-form ref="searchForm" inline label-width="90px">
      <el-form-item label="考试编号：">
        <el-input size="medium" style="width:150px;" v-model="form.spaperNo" placeholder="请输入考试编号" type="text" />
      </el-form-item>
      <el-form-item label="考试名称：">
        <el-input size="medium" style="width:150px;" v-model="form.spaperName" placeholder="请输入考试名称" type="text" />
      </el-form-item>
      <el-form-item label="考试状态：">
        <el-select size="medium" v-model="form.npublishStatus" style="width:150px;">
          <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.STATUS" :key="index"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="领域：">
        <el-select 
          size="medium" 
          v-model="form.sfieldIds" 
          multiple 
          collapse-tags 
          filterable
          style="width:260px;" 
          placeholder="请选择领域" 
          @change="getProductList"
        >
          <el-option :value="item.key" :label="item.value" v-for="(item, index) in domianList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品：">
        <el-select 
          size="medium" 
          v-model="form.sproductIds" 
          filterable
          multiple 
          collapse-tags 
          style="width:260px;"
          placeholder="请选择产品"
          :disabled="noProduct"
          @change="isForbidBrand" 
        >
          <el-option :value="item.key" :label="item.value" v-for="(item, index) in productList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌：">
        <el-select size="medium" v-model="form.sbrandId" filterable style="width:260px;" placeholder="请选择品牌" :disabled="noBrand">
          <el-option :value="item.key" :label="item.value" v-for="(item, index) in brandList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="关联课程：">
        <el-input size="medium" style="width:150px;" v-model="form.courseName" placeholder="请输入关联课程" type="text" />
      </el-form-item> -->
      <el-form-item label="组卷方式：">
        <el-select size="medium" v-model="form.norganizedPattern" style="width:150px;">
          <el-option :value="1" label="选题组卷"></el-option>
          <el-option :value="2" label="随机组卷"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="总分：">
        <el-input size="medium" style="width:150px;" v-model="form.ntotalScore" placeholder="请输入总分" type="text" />
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker
          size="medium"
          v-model="form.pickerTime"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="起止时间：">
        <el-date-picker
          size="medium"
          v-model="form.dpublishTime"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px;"
        ></el-date-picker>
      </el-form-item>
      
      
      
      
      <el-form-item>
        <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="medium" type="success" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- max-height="250" -->
    <el-table
      :stripe="true"
      v-loading="listLoading"
      :data="tableData"
      style="width: 100%"
      height="510"
      >
      <el-table-column prop="spaperNo" label="考试编号" show-overflow-tooltip width="140"></el-table-column>
      <el-table-column prop="spaperName" label="考试名称" show-overflow-tooltip width="250"></el-table-column>
      <el-table-column label="考试状态" width="140">
        <template slot-scope="scope">
          <span>{{!scope.row.npublishStatus?'未发布':'已发布'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="领域" show-overflow-tooltip width="140">
        <template slot-scope="scope">
          <span>{{scope.row.sfield || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="产品" show-overflow-tooltip width="140">
        <template slot-scope="scope">
          <span>{{scope.row.sproduct || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="品牌" show-overflow-tooltip width="140">
        <template slot-scope="scope">
          <span>{{scope.row.sbrand || '--'}}</span>
        </template>
      </el-table-column>
      
      <!-- <el-table-column label="关联课程" show-overflow-tooltip width="250">
        <template slot-scope="scope">
          <span>{{scope.row.courseName||'--'}}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="组卷方式" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.norganizedPattern == 1?'选题组卷':'随机组卷' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.dcreateDate||'--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="起止时间" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.dpublishDate }}</span>
          <span> 至</span>
          <span style="display: block;">{{ scope.row.dunpublishDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="总分" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.ntotalScore||'--' }}</span>
        </template>
      </el-table-column>
      
      
      <el-table-column label="操作" fixed="right" width="280">
        <template slot-scope="scope">
          <div class="btn-groups">
            <template v-if="!(typeof(actionData.examinationkc_edit) != 'undefined'&&!actionData.examinationkc_edit)">
              <el-button @click.native.prevent="editQuestionsHandleCommand(scope.row)" size="mini">编辑</el-button>
            </template>
            <template v-if="!(typeof(actionData.examinationkc_results) != 'undefined'&&!actionData.examinationkc_results)">
              <el-button @click.native.prevent="scoreQueryPush(scope.row)" type="primary" size="mini" v-if="scope.row.npublishStatus">成绩查询</el-button>
            </template>
            <template v-if="!(typeof(actionData.examinationkc_isrelease) != 'undefined'&&!actionData.examinationkc_isrelease)">
              <el-button @click.native.prevent="clickIsPublish(scope.row)" type="primary" size="mini" v-if="!scope.row.npublishStatus">发布</el-button>
              <el-button @click.native.prevent="clickIsPublish(scope.row)" type="warning" size="mini" v-if="scope.row.npublishStatus">取消发布</el-button>
            </template>
            <template v-if="!(typeof(actionData.examinationkc_delete) != 'undefined'&&!actionData.examinationkc_delete)">
              <template v-if="!scope.row.npublishStatus">
                <el-popconfirm
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要删除此课程考试吗？"
                  @confirm="deleteRow(scope.row)"
                >
                  <el-button slot="reference" type="danger" size="mini" class="-none">删除</el-button>
                </el-popconfirm>
              </template>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;" v-show="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
import { mapState } from 'vuex'
import { getProductSelect } from '@/service/area'
import { getStorageUserRoleId, getActionData } from '@/utils/store'
import {
    examinationExamList,            //获取考试列表
    examinationIsPublish,           //发布/取消发布
    examinationDel,                 //删除列表某一项
} from "@/service/examination";
  export default {
    data() {
      return {
        actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
        
        listLoading: false,
        TEST_TYPE,
        QUESTIONS_TYPE,
        productList: [],
        form: {
          pageNum: 1,
          pageSize: 10,
          rational: true,

          spaperNo: '',         //考试编号
          spaperName: '',       //考试名称
          npublishStatus: '',   //0已发布 1未发布
          
          sfieldIds: '',         //领域id
          sproductIds: '',       //产品
          sbrandId: '',         //品牌

          courseName: '',       //关联课程
          pickerTime:[],        //创建时间
          dpublishTime:[],      //起止时间
          ntotalScore: '',      //总分

          norganizedPattern: '',//组卷方式
          npaperAttribute: 2,   //1=认证考试，2=课程考试

        },
        searchData:{},
        oraginForm:{},
        total: 0,                       //总条数

        tableData: [],

        noProduct: false,               //禁止产品
        noBrand: false,                 //禁止品牌
      }
    },
    activated(){
      this.handleSearch()
    },
    created() {
      this.oraginForm = JSON.parse(JSON.stringify(this.form))
    },
    computed: {
      ...mapState({
        domianList: state => state.area.domianList,
        brandList: state => state.area.brandList
      })
    },
    mounted() {

    },
    methods: {
       // 获取产品
      getProductList(){
          if(this.form.sfieldIds.length >= 2) {
            this.noProduct = true;
            this.noBrand = true;
            this.form.sproductIds = []
            this.form.sbrandId = ''
          }else{
            this.noProduct = false;
            this.noBrand = false;
            getProductSelect({productDomainId:this.form.sfieldIds[0]}).then(res=>{
              res.Result == 1 ? this.productList=res.Data: []
            })
          }
      },
      //产品大于2禁止品牌
      isForbidBrand() {
        if(this.form.sproductIds.length >= 2) {
          this.noBrand = true;
          this.form.sbrandId = ''
        }else{
          this.noBrand = false;
        }
      },
      handleSearch() {
        this.searchData = Object.assign({}, this.form)
        this.handleCurrentChange(1)
      },
      handleReset() {
        this.form = JSON.parse(JSON.stringify(this.oraginForm))
        this.handleSearch()
      },
      async GetExaminationExamList(){
        this.listLoading = true
        let data = JSON.parse(JSON.stringify(this.searchData))
        !data.spaperNo && delete data.spaperNo
        !data.sfieldIds && delete data.sfieldIds
        !data.sproductIds && delete data.sproductIds
        !data.sbrandId && delete data.sbrandId
        !data.spaperName && delete data.spaperName
        !data.npaperCategory && delete data.npaperCategory
        !data.courseName && delete data.courseName
        !data.norganizedPattern && delete data.norganizedPattern
        data.ntotalScore==='' && delete data.ntotalScore
        data.npublishStatus==='' && delete data.npublishStatus
        if (data.pickerTime && data.pickerTime.length) {
          data.dcreateDateBegin = data.pickerTime[0] + ' 00:00:01'
          data.dcreateDateEnd = data.pickerTime[1] + ' 23:59:59'
        }
        delete data.pickerTime
        if(data.dpublishTime && data.dpublishTime.length) {
          data.dpublishDateBegin = data.dpublishTime[0] + ' 00:00:01'
          data.dunpublishDateEnd = data.dpublishTime[1] + ' 23:59:59'
        }
        delete data.dpublishTime
        let res = await examinationExamList(data)
        this.listLoading = false
        this.tableData = res.Data.datas
        this.total = res.Data.total
      },
      clickIsPublish(rows){
        let data = {
          "npublishStatus": rows.npublishStatus?0:1,
          "pkid": rows.pkid,
          "userId": getStorageUserRoleId()
        }
        examinationIsPublish(data).then((res)=>{
          let tips = ''
          if(res.Result != 1) {
            if(!rows.npublishStatus){
              tips = '发布失败，请重新发布'
            }else {
              tips = '取消发布失败，请重新取消发布'
            }
            return this.$message.error(tips)
          }
          tips = !rows.npublishStatus?'发布成功！':'取消发布成功！'
          this.$message.success(tips);
          this.GetExaminationExamList()
        })
      },




       //删除列表某一项
      deleteRow(rows) {
        let data = {
          pkid: rows.pkid
        }
        examinationDel(data).then(res=> {
          if(res.Result != 1) {
            return this.$message.error('删除失败，请重新确认删除');
          }
          this.$message.success('删除成功！');
          this.GetExaminationExamList()
        })
      },



      handleSizeChange(val) {
        if (this.listLoading) return
        this.form.pageNum = 1
        this.form.pageSize = val
        this.searchData.pageNum = 1
        this.searchData.pageSize = val
        this.GetExaminationExamList()
      },
      handleCurrentChange(val) {
        if (this.listLoading) return
        this.form.pageNum = val
        this.searchData.pageNum = val
        this.GetExaminationExamList()
      },
      handleCommand(command) {
        this.$router.push('/examination/createCourse?type='+command)
      },
      editQuestionsHandleCommand(rows){
        let command = '',activeName =''
        if(rows.norganizedPattern == 1) {
          command = 'a'
          activeName = 'add'
        } else {
          command = 'b'
          activeName = 'addtwo'
        }
        this.$router.push('/examination/createCourse?type='+command+'&activeName='+ activeName +'&spaperNo='+rows.spaperNo)
      },
      // 点击成绩查询
      scoreQueryPush(rows) {
        this.$router.push('/examination/childAchievement?spaperNo='+rows.spaperNo+'&name='+rows.spaperName+'&attribute=2')
      }
    }
  }
</script>

<style lang="scss">
.box {
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .row-bg {
    padding: 10px 14px;
    background-color: #f9fafc;
  }
  .none {
    display: none;
  }
}

</style>